import { render } from "./FilterListItem.vue?vue&type=template&id=96b2e56c&scoped=true&ts=true"
import script from "./FilterListItem.vue?vue&type=script&lang=ts"
export * from "./FilterListItem.vue?vue&type=script&lang=ts"

import "./FilterListItem.vue?vue&type=style&index=0&id=96b2e56c&lang=scss&scoped=true"

import exportComponent from "C:\\BuildAgent\\work\\bd59560cf4570ff\\src\\TicketSolutions.Personalisation.Client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96b2e56c"]])

export default __exports__